<template>
  <div class="container">
    <footer class="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
      <div class="col-md-4 d-flex align-items-center">
        <a href="https://www.canalls-project.eu/"
           class="mb-3 me-2 mb-md-0 text-body-secondary text-decoration-none lh-1">
          <img src="../assets/africa.png"
               alt="Logo"
               width="40"
               height="40"
               class="d-inline-block align-top me-2"/>
        </a>
        <span class="mb-3 mb-md-0 text-body-secondary">© 2025 CANALLS Project</span>
      </div>
      <ul class="col-md-4 justify-content-end list-unstyled">
        <li><span class="versionInfo">{{ $t('Footerbar.frontend') }} {{ frontendVersion }}</span></li>
        <li><span class="versionInfo">{{ $t('Footerbar.backend') }} {{ backendVersion }}</span></li>
      </ul>
      <ul class="nav col-md-4 justify-content-end list-unstyled d-flex">
        <li class="ms-3"><a class="text-body-secondary"
                            href="https://www.linkedin.com/company/canalls-project/"
                            target="_blank"><i class="bi bi-linkedin"></i></a></li>
        <li class="ms-3"><a class="text-body-secondary"
                            href="https://x.com/CANALLS_Project?mx=2"
                            target="_blank"><i class="bi bi-twitter-x"></i></a></li>
        <li class="ms-3"><a class="text-body-secondary"
                            href="https://www.facebook.com/people/Canalls-Project/100089626317019/"
                            target="_blank"><i class="bi bi-facebook"></i></a></li>
        <li class="ms-3"><a class="text-body-secondary"
                            href="https://www.youtube.com/@CANALLSPROJECT"
                            target="_blank"><i class="bi bi-youtube"></i></a></li>
      </ul>
    </footer>
  </div>
</template>

<script>
import {version} from "../../package.json";
import {getBackendVersion} from "@/utils";

export default {
  data() {
    return {
      frontendVersion: version,
      backendVersion: '0.0.0'
    }
  },
  async beforeMount() {
    let response = await getBackendVersion();
    if (response.status === 200) {
      this.backendVersion = response.data.version;
    } else {
      this.backendVersion = "0.0.0";
    }
  }
};
</script>

